import { render } from "./WeekSelector.vue?vue&type=template&id=296ecb29&scoped=true"
import script from "./WeekSelector.vue?vue&type=script&lang=js"
export * from "./WeekSelector.vue?vue&type=script&lang=js"

import "./WeekSelector.vue?vue&type=style&index=0&id=296ecb29&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296ecb29"]])

export default __exports__